import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["incomingPanel", "activePanel", "incomingTab", "activeTab"];

  showIncoming() {
    if (this.hasIncomingPanelTarget) this.incomingPanelTarget.classList.remove("hidden");
    if (this.hasActivePanelTarget) this.activePanelTarget.classList.add("hidden");
    this.setTabStyles(true);
  }

  showActive() {
    if (this.hasIncomingPanelTarget) this.incomingPanelTarget.classList.add("hidden");
    if (this.hasActivePanelTarget) this.activePanelTarget.classList.remove("hidden");
    this.setTabStyles(false);
  }

  setTabStyles(incomingSelected) {
    if (this.hasIncomingTabTarget) {
      const tab = this.incomingTabTarget;
      tab.classList.toggle("bg-white", incomingSelected);
      tab.classList.toggle("shadow-sm", incomingSelected);
      tab.classList.toggle("text-[#414651]", incomingSelected);
      tab.classList.toggle("bg-transparent", !incomingSelected);
      tab.classList.toggle("text-[#717680]", !incomingSelected);
      tab.classList.toggle("hover:text-[#636872]", !incomingSelected);
      tab.setAttribute("aria-selected", incomingSelected ? "true" : "false");
    }
    if (this.hasActiveTabTarget) {
      const tab = this.activeTabTarget;
      const activeSel = !incomingSelected;
      tab.classList.toggle("bg-white", activeSel);
      tab.classList.toggle("shadow-sm", activeSel);
      tab.classList.toggle("text-[#414651]", activeSel);
      tab.classList.toggle("bg-transparent", !activeSel);
      tab.classList.toggle("text-[#717680]", !activeSel);
      tab.classList.toggle("hover:text-[#636872]", !activeSel);
      tab.setAttribute("aria-selected", activeSel ? "true" : "false");
    }
  }

  open(event) {
    const id = event.currentTarget.dataset.dialogId;
    if (id) document.getElementById(id)?.showModal();
  }

  closeAndOpen(event) {
    const el = event.currentTarget;
    const closeId = el.dataset.closeId;
    const openId = el.dataset.openId;
    if (closeId) document.getElementById(closeId)?.close();
    if (openId) document.getElementById(openId)?.showModal();
  }

  closeDialog(event) {
    const id = event.currentTarget.dataset.dialogId;
    if (id) document.getElementById(id)?.close();
  }
}
